
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/quickEditEngine/components/styles/innerDrillIn.scss.css.virtualfile';
        module.exports = {"innerDrillInPanel":"_innerDrillInPanel_18m2f_7","innerDrillInContent":"_innerDrillInContent_18m2f_15"};